import React, { useRef, useEffect } from "react";
import Header from "./Header";
import { useWindowDimension } from "../../../../../hooks/generic/PageUI/useWindowDimension";
import useTabFocus from "../../../../../hooks/generic/Utils/useTabFocus";
import i18n from "../../../../../utils/ChrI18n";

/*
props = {
  isOpen: <boolean>,
  openedAtleastOnce: <boolean>,
  header: <string | component>,
  children: <component>,
  onClose: <handler>,
  widthClass: <css className string>
}
*/

const ChrOffCanvas = (props) => {
  const { 
    isOpen, 
    onClose, 
    children, 
    openedAtleastOnce, 
    header, 
    headerClass = "", 
    customHeader, 
    skipDefaultHeader = false, 
    heightClass = '', 
    canvasClassName = "", 
    widthClass = 'cui-off-canvas-responsive-width', 
    htmlBodyClass = '', // used for restricting scroll (hiding body scrollbar) other global styles like modal visibilities
    transformCanvasClass = 'chr-off-canvas-right',
    transformOverlayClass = 'chr-off-overlay-right',
    removeOnClose = false
  } = props;
  const windowDimension = useWindowDimension({includeFooter: false});
  const canvasClasses = `d-flex flex-column chr-off-canvas chr-off-canvas-animation position-fixed bg-white ${heightClass} ${widthClass} ${transformCanvasClass} ${canvasClassName} ${isOpen ? 'show' : ''}`;
  const overlayClasses = `chr-off-canvas-overlay ${transformOverlayClass} ${isOpen ? 'show' : ''}`;
  const bodyRef = useRef(document.querySelector('body'));
  const removeAddedBodyClass = () => { 
    if(bodyRef.current.querySelectorAll('.chr-off-canvas.show').length === 0){
      htmlBodyClass && bodyRef.current.classList.remove(htmlBodyClass);
      bodyRef.current.classList.remove('chr-off-canvas-open');
    }
  }


  const {handleKeyDown} = useTabFocus();

  useEffect(() => {
    if(openedAtleastOnce){
      if (isOpen) {
        bodyRef.current.classList.add('chr-off-canvas-open');
        htmlBodyClass && bodyRef.current.classList.add(htmlBodyClass);
      }
      else {
        removeAddedBodyClass();
      }
    }
    return () => {
      removeAddedBodyClass();
    }
  }, [isOpen]);

  const firstFocusableElementRef = useRef(null);
  useEffect(() => {
    if (isOpen && firstFocusableElementRef.current) {
      firstFocusableElementRef.current.focus();
    }
  }, [isOpen])

  return (
    <>
      <div className={ overlayClasses } onClick={ onClose } style={{height: `${windowDimension.height}px`}}/>
      <div ref={firstFocusableElementRef} role="presentation" className={ canvasClasses } style={{height: `${windowDimension.height}px`}} tabIndex={isOpen ? "0" : "-1"}>
        { openedAtleastOnce && (removeOnClose ? isOpen : true) &&
          <>
            {skipDefaultHeader  && customHeader && customHeader}
            {!skipDefaultHeader && <div className={`d-flex flex-row p-2 chr-off-canvas-header-section`}>
              <Header header={ header } headerClass={ headerClass } />
              <div tabIndex="0" aria-hidden="true" onKeyDown={ handleKeyDown } className="p-3 font-16 align-self-baseline ml-auto" onClick={ onClose }>
                <i className="fa-regular fa-times cursor-pointer" />
              </div>
              <button className="sr-only" aria-label={i18n.t("display_string.Close")} role="button" onClick={ onClose } > </button>
            </div>}
            { children }
          </>
        }
      </div>
    </>
  )
}

export default ChrOffCanvas;
